import { Flex, Box } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/toast";
import { useForm } from "react-hook-form";
import { Route } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import {
  Brand,
  Button,
  Heading,
  Input,
  Link,
  PasswordInput,
  Text,
} from "../../../components";
import { useApp } from "../../../contexts";
import {
  useRemoveRefresh,
  useBlockAuthenticatedUserFromPage,
} from "../../../hooks";
import { OnBoardingFormLayout } from "../../../layouts";
import { getUserRole, requestRegister } from "../../../services";
import { capitalizeFirstLetter } from "../../../utils";
import { useEffect, useState } from "react";

const RegistrationPage = () => {
  useRemoveRefresh();
  useBlockAuthenticatedUserFromPage();

  const [userroleid, setuserroleid] = useState();

  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    reset,
    getValues,
  } = useForm();
  const formValues = getValues();
  const appManager = useApp();

  // useEffect(() => {
  //   getUserRole().then((response) => {
  //     setuserroleid(response.data[0].id);

  //     // appManager.setUserRole(response.data.data.role);
  //   });
  // }, [appManager]);

  const onSubmit = async (data) => {
    try {
      // await getUserRole(data);
      await getUserRole().then((response) => {
        setuserroleid(response.data.userRoles[0].id);

        // appManager.setUserRole(response.data.data.role);
      });
      Reflect.deleteProperty(data, "confirmPassword");
      data = {
        ...data,
        userRoleId: userroleid,
      };

      await requestRegister(data);
      toast({
        description: capitalizeFirstLetter(
          "Account Regitered Sucessfully, please check email to verify email"
        ),
        position: "top",
        status: "success",
      });
      // await appManager.handleLogin(data);
      // reset();
    } catch (err) {
      console.error(err);
      toast({
        description: capitalizeFirstLetter(err.message),
        position: "top",
        status: "error",
      });
    }
  };

  const shouldDisableSubmit =
    isSubmitting ||
    appManager.loginSuccess ||
    appManager.state.loadingStatuses.metadata ||
    appManager.state.errorStatuses.metadata;

  return (
    <OnBoardingFormLayout
      renderHeader={() => (
        <>
          <Brand />

          <Heading as="h1" fontSize="heading.h3" mt={10}>
            Create Account
          </Heading>
        </>
      )}
      renderInputs={() => (
        <>
          <Input
            id="firstName"
            label="First name"
            error={errors.firstName?.message}
            {...register("firstName", {
              required: "First Name can't be empty",
              minLength: {
                value: 2,
                message: "Please enter a valid name",
              },
            })}
          />

          <Input
            id="lastName"
            label="Last name"
            error={errors.lastName?.message}
            {...register("lastName", {
              required: "Last Name can't be empty",
              minLength: {
                value: 2,
                message: "Please enter a valid name",
              },
            })}
          />

          <Input
            id="email"
            type="email"
            label="Email"
            error={errors.email?.message}
            {...register("email", {
              required: "Email can't be empty",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Enter a valid e-mail address",
              },
            })}
          />

          <PasswordInput
            id="password"
            label="Password"
            error={errors.password?.message}
            {...register("password", {
              required: "Password can't be empty",
              minLength: {
                value: 3,
                message: "Password should not be less than 3 characters",
              },
            })}
          />

          <PasswordInput
            id="confirmPassword"
            label="Confirm password"
            error={errors.confirmPassword?.message}
            {...register("confirmPassword", {
              required: "Confirm password can't be empty",
              validate: (value) =>
                value === formValues.password || "Password must match",
            })}
          />
        </>
      )}
      onSubmit={handleSubmit(onSubmit)}
      renderSubmit={(props) => (
        <Button
          {...props}
          isLoading={shouldDisableSubmit}
          disabled={shouldDisableSubmit}
          loadingText={
            appManager.state.errorStatuses.metadata
              ? "Error! Please refresh the page"
              : "Please wait..."
          }
        >
          Submit
        </Button>
      )}
      renderFooter={() => (
        <Flex flexDirection="column">
          <Text pt={3} pb={6} textAlign="center" as="level1" fontWeight="500">
            <i>or</i>
          </Text>

          <Flex pt={3} justifyContent="center" alignItems="flex-end">
            <Text>Already have an account?</Text>

            <Text color="primary.base" ml={2}>
              <Link href="/auth/signin">Log In</Link>
            </Text>
          </Flex>
        </Flex>
      )}
    />
  );
};

export const RegistrationPageRoute = ({ ...rest }) => {
  return (
    <Route {...rest} render={(props) => <RegistrationPage {...props} />} />
  );
};
